import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot} from "@angular/router";
import {NavigationService} from "../navigation/navigation.service";
import {DetailService} from "./detail.service";
import {HelperService} from "../helperService";

/**
 * Class ProfileResolver
 * @desc Klasse, die Profil laedt, ausgelagert um UserID nicht in der URL darstellen zu muessen
 */
@Injectable()
export class ProfileResolver
{

    /**
	 * Function > constructor
	 * @param {DetailService} detail_service
	 * @param navigation_service
	 * @param helper_service
	 */
    constructor(
        private detail_service: DetailService,
        private navigation_service: NavigationService,
		private helper_service: HelperService
        )
    {} // end function constructor

	/**
 	 * @param route
	 */
    resolve(route: ActivatedRouteSnapshot)
    {
		let route_menu = "profile";
		let route_submenu = "users";

        let config_endpoint = this.navigation_service.getDetailConfigEndpointByRoute(route_menu, route_submenu);

		let content_endpoint = this.navigation_service.getDataEndpointByRoute(route_menu, route_submenu);

		let http_content_params = this.navigation_service.getDataEndpointParamsByRoute(route_menu, route_submenu);

		let current_user = this.helper_service.getFromLocalstorage("current_user");

		// Userid aus sessionstorage holen
		content_endpoint = content_endpoint.replace(":id", current_user._id);

		return this.detail_service.getFormFields(config_endpoint, content_endpoint, http_content_params);

    } // end function resolve


} // end class StandaloneDetailResolver
